export default __webpack_public_path__ + "static/media/silver play button.09d918e8.png";